import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'

export default {
  state: {
    TeamMember: {
      Parent: {
        'Id': 0,
        'PageTitle': '',
        'SubscriptionModuleActivation_Id': 0,
        'HeaderElements': '',
        'FooterElements': ''
      },
      Persons: []
    }
  },
  getters: {
    TeamMember: state => state.TeamMember,
    TeamParent: state => state.TeamMember.Parent,
    Persons: state => state.TeamMember.Persons
  },
  mutations: {
    [mutationNames.SET_TEAM_PARENT] (state, Parent) {
      state.TeamMember.Parent = Parent
    },
    [mutationNames.SET_TEAM_MEMBER] (state, Persons) {
      state.TeamMember.Persons = Persons
    },
    [mutationNames.UPDATE_TEAMPARENT] (state, obj) {
      Object.assign(state.TeamMember.Parent, obj)
    },
    [mutationNames.UPDATE_TEAMPRESON] (state, {Id, payload}) {
      let person = state.TeamMember.Persons.find(person => person.Id === Id)
      if (person) {
        Object.assign(person, payload)
      }
    },
    [mutationNames.UPDATE_TEAM_PERSON_IMAGE] (state, uploadResponse) {
      let person = state.TeamMember.Persons.find(person => person.Id === uploadResponse.MemberId)
      if (person) {
        Object.assign(person, {
          'PersonImage': uploadResponse.ImageName ? uploadResponse.ImageName : null
        })
      }
    },
    [mutationNames.ADD_TEAMPRESON] (state, payload) {
      let person = state.TeamMember.Persons.find(person => person.Id === payload.Id)
      if (!person) {
        state.TeamMember.Persons.push(payload)
      }
    }
  },
  actions: {
    updateParentSettings ({ commit }, payload) {
      commit(mutationNames.UPDATE_TEAMPARENT, payload)
    },
    async setTeamMembers ({ dispatch, commit }, persons) {
      const updatedpersons = persons ? persons.map((person, index) => {
        return {
          ...person,
          OrderId: index + 1
        }
      }) : []
      await dispatch('saveTeamPersonList', updatedpersons)
      commit(mutationNames.SET_TEAM_MEMBER, updatedpersons)
    },
    updatePersonSettings ({ commit }, obj) {
      commit(mutationNames.UPDATE_TEAMPRESON, obj)
    },
    async getTeamParent ({ dispatch, commit, getters }, SubscriptionModuleId) {
      const response = await api.AppModules.GetTeamParent(SubscriptionModuleId)
      if (!response) {
        throw new Error('No data from API. ;(')
      }
      commit(mutationNames.SET_TEAM_PARENT, response)
      await dispatch('getTeamMembers', response.Id)
    },
    async getTeamMembers ({ commit, getters }, ModulesTeamMembersId) {
      const response = await api.AppModules.GetTeamMembers(ModulesTeamMembersId)
      if (!response) {
        throw new Error('No data from API. ;(')
      }
      commit(mutationNames.SET_TEAM_MEMBER, response)
    },
    async updateTeamPresonImage ({ getters, commit }, uploadResponse) {
      let Preson = getters.Persons.find(per => per.Id === uploadResponse.MemberId)
      if (Preson && Preson.Id !== '00000000-0000-0000-0000-000000000000') {
        await api.AppModules.patchTeamPreson(Preson.Id, {
          PersonImage: uploadResponse.ImageName ? uploadResponse.ImageName : null
        })
      }
      commit(mutationNames.UPDATE_TEAM_PERSON_IMAGE, uploadResponse)
    },
    saveTeamParentSettings ({ dispatch, getters }) {
      let TeamParentClone = Object.assign({}, getters.TeamParent)
      return api.AppModules.SaveTeamParent(TeamParentClone)
    },
    saveTeamPersonSettings ({ dispatch, getters }, payload) {
      return api.AppModules.SaveTeamPresonInfo(payload)
    },
    copyTeamPersonSettings ({ dispatch, getters }, payload) {
      return api.AppModules.CopyTeamPresonInfo(payload)
    },
    saveTeamPersonList ({ dispatch, getters }, payload) {
      return api.AppModules.SaveTeamPresonList(payload)
    },
    deleteTeamPreson ({ dispatch, getters }, personId) {
      return api.AppModules.DeleteTeamPreson(personId)
    },
    addTeamPreson ({ commit }, payload) {
      commit(mutationNames.ADD_TEAMPRESON, payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/appModules/team.js